import { useLocation } from "react-router-dom";
import { Address, BannerLink } from "./style";

const APP_HOST = "app.fictivereality.com";

export const getMovedAppUrl = currentUrl => {
  const destinationUrl = new URL(currentUrl);
  destinationUrl.protocol = "https:";
  destinationUrl.host = APP_HOST;
  destinationUrl.port = "";
  return destinationUrl.href;
};

const AppMovedBanner = () => {
  const location = useLocation();
  const currentUrl = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

  if (window.location.hostname === APP_HOST) return null;

  return (
    <BannerLink href={getMovedAppUrl(currentUrl)}>
      This URL address is going away. Continue at <Address>{APP_HOST} →</Address> (you may need to sign in again, and
      remember to update your bookmarks)
    </BannerLink>
  );
};

export default AppMovedBanner;
